export const PHOTOS_PER_PAGE = 36
export const PHOTO_HASH_PREFIX = 'photo-'
